<template>
  <v-navbar-menu-item :horizontal="horizontal" v-if="mounted" :icon="icon" language>
    {{name}}
    <template v-slot:items>
      <v-navbar-menu-item v-if="!!getLocaleProps('da')" v-bind="getLocaleProps('da')" @click="$emit('change', { name: list.da.name, locale: 'da' })">
        <div class="d-flex align-items-center">
          <div class="img mr-2" :style="{ backgroundImage: `url('${list.da.icon}')` }" role="img" aria-label="danish flag"/>
          {{list.da.name}}
        </div>
      </v-navbar-menu-item>
      <v-navbar-menu-item v-if="!!getLocaleProps('en')" v-bind="getLocaleProps('en')" @click="$emit('change', { name: list.en.name, locale: 'en' })">
        <div class="d-flex align-items-center">
          <div class="img mr-2" :style="{ backgroundImage: `url('${list.en.icon}')` }" role="img" aria-label="english flag"/>
          {{list.en.name}}
        </div>
      </v-navbar-menu-item>
      <v-navbar-menu-item v-if="!!getLocaleProps('de')" v-bind="getLocaleProps('de')" @click="$emit('change', { name: list.de.name, locale: 'de' })">
        <div class="d-flex align-items-center">
          <div class="img mr-2" :style="{ backgroundImage: `url('${list.de.icon}')` }" role="img" aria-label="german flag"/>
          {{list.de.name}}
        </div>
      </v-navbar-menu-item>
      <v-navbar-menu-item v-if="!!getLocaleProps('pl')" v-bind="getLocaleProps('pl')" @click="$emit('change', { name: list.pl.name, locale: 'pl' })">
        <div class="d-flex align-items-center">
          <div class="img mr-2" :style="{ backgroundImage: `url('${list.pl.icon}')` }" role="img" aria-label="polish flag"/>
          {{list.pl.name}}
        </div>
      </v-navbar-menu-item>
      <v-navbar-menu-item v-if="!!getLocaleProps('ru')" v-bind="getLocaleProps('ru')" @click="$emit('change', { name: list.ru.name, locale: 'ru' })">
        <div class="d-flex align-items-center">
          <div class="img mr-2" :style="{ backgroundImage: `url('${list.ru.icon}')` }" role="img" aria-label="russian flag"/>
          {{list.ru.name}}
        </div>
      </v-navbar-menu-item>
      <v-navbar-menu-item v-if="!!getLocaleProps('ro')" v-bind="getLocaleProps('ro')" @click="$emit('change', { name: list.ro.name, locale: 'ro' })">
        <div class="d-flex align-items-center">
          <div class="img mr-2" :style="{ backgroundImage: `url('${list.ro.icon}')` }" role="img" aria-label="romanian flag"/>
          {{list.ro.name}}
        </div>
      </v-navbar-menu-item>
    </template>
  </v-navbar-menu-item>
</template>

<script>
import { localesMixin } from "./locales.mixin";

export default {
  mixins: [localesMixin],
  data() {
    return {
      mounted: false
    };
  },
  mounted() {
    this.mounted = true;
  },
  props: {
    locales: {
      type: Object,
      default: () => {}
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  }
};
</script>
